<template>
  <div class="navbar-wrapper">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary mobile-sticky">
      <div class="container-fluid">
        <a class="navbar-brand d-lg-none" href="#">KoP Buff</a>

        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div id="navbarNav" class="collapse navbar-collapse">
          <ul class="navbar-nav me-auto">
            <li class="nav-item active">
              <slot name="Home"></slot>
            </li>

            <li class="nav-item">
              <slot name="Matches"></slot>
            </li>

            <li class="nav-item">
              <slot name="Heros"></slot>
            </li>

            <li class="nav-item">
              <slot class="nav-link" name="Items"></slot>
            </li>

            <li class="nav-item">
              <slot name="Leaderboard"></slot>
            </li>
          </ul>
          <ul class="navbar-nav navbar-dark ms-auto">
            <li class="nav-item">
              <a class="nav-link" href="https://discord.gg/U3TT62TjZB" target="_blank">Discord</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://leagueofpixels.eu/?ref=KOPBuff" target="_blank">Play Game</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'KopNavbar',

  props: {},

  methods: {},
}
</script>

<style scoped>
.navbar-wrapper {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}

.mobile-sticky {
  position: sticky;
  top: 0;
  z-index: 1030;
  border-color: var(--kop-border);
  border-radius: 8px;
  background: rgba(9, 18, 24, 0.78) !important;
  box-shadow: 0 16px 42px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(10px);
}

.nav-link {
  border-radius: 8px;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.nav-link:hover {
  background: rgba(255, 191, 102, 0.08);
  transform: translateY(-1px);
}

/* Mobile sticky navbar */
@media (max-width: 991.98px) {
  .mobile-sticky {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1030;
    margin: 0 !important;
  }

  .navbar-wrapper {
    margin-top: 0;
    margin-bottom: 0;
    /* Add padding to account for fixed navbar */
    padding-top: 70px;
  }

  .navbar-brand {
    font-weight: bold;
    font-size: 1.1rem;
  }

  .navbar-toggler {
    border: none;
    padding: 0.25rem 0.5rem;
  }

  .navbar-toggler:focus {
    box-shadow: none;
  }

  .navbar-collapse {
    position: absolute;
    top: 100%;
    left: 1rem;
    right: 1rem;
    background: rgba(9, 18, 24, 0.96);
    margin-top: 0.5rem;
    padding: 0.5rem;
    border-radius: 8px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25), 0 4px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid var(--kop-border);
    backdrop-filter: blur(10px);
    overflow: hidden;
  }

  .navbar-nav {
    gap: 12px;
    padding: 0.5rem 0;
  }

  .nav-link {
    padding: 0.75rem 1.25rem !important;
    margin: 0 0.5rem;
    border-radius: 8px;
    transition: all 0.2s ease;
    color: rgba(255, 255, 255, 0.9) !important;
    font-weight: 500;
    position: relative;
    overflow: hidden;
  }

  .nav-link::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transition: left 0.5s ease;
  }

  .nav-link:hover {
    background-color: rgba(255, 191, 102, 0.1);
    color: #ffffff !important;
    transform: translateX(4px);
  }

  .nav-link:hover::before {
    left: 100%;
  }

  .nav-link:active {
    transform: translateX(2px);
  }

  /* Adjust spacing for external links */
  .navbar-nav.ms-auto {
    margin-top: 0;
    padding-top: 0.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    margin-bottom: 0.5rem;
  }

  .navbar-nav.ms-auto .nav-link {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .navbar-nav.ms-auto .nav-link:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
  }
}

/* Desktop adjustments */
@media (min-width: 992px) {
  .navbar-wrapper {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }

  .mobile-sticky {
    padding: 0 1.5rem;
  }
}
</style>
